import { store } from '../redux/store';
import { ActionTypes, ReduxAction } from '../redux/actions/types';
import { findTranslation, replacePlaceholderValues } from './translationUtils';
import {
  ERROR,
  FORM_VALIDATION,
  INFO,
} from '../layouts/notification/Notification';
import { Message, Translation } from '../api';
import { Dispatch } from 'redux';

/**
 * Erstellt eine Notification die dargestellt wird entweder als Modales Fenster (im Fall
 * von severity == Error, oder im Bereich unter der Navbar (z.b. wie bei Auftrag Speichern)
 * wenn die severity == INFO ist.
 *
 * @param key der schluessel des Translations
 * @param placeHolderValues ein array mit die Platzhalter Werte die ersetzt Werden sollen
 * @param fieldName
 * @param severity ob die Nachricht vom typ ERROR (Modales Fenster) oder INFO ist
 * @param timeout wie lange die Nachricht dargestellt werden soll (default 5000ms)
 */
export const setNotification = (
  key: string,
  placeHolderValues: [],
  severity = INFO,
  timeout: number | null = 5000,
  fieldName?: string
): void => {
  const messages = [...store.getState().Notifications.messageList];
  messages.sort((a, b) => a.id - b.id);
  const message: Message = createMessage(
    key,
    severity,
    placeHolderValues,
    fieldName,
    messages.length > 0 && Math.sign(messages[0]) === -1 ? messages[0] - 1 : -1
  );

  store.dispatch({
    type: ActionTypes.ADD_NOTIFICATION,
    payload: message,
  });

  if (timeout !== null) {
    setTimeout(() => {
      store.dispatch({
        type: ActionTypes.REMOVE_NOTIFICATION,
        payload: {
          id: message.id,
        },
      });
    }, timeout);
  }
};

export const removeNotifications = (): void => {
  store.dispatch({
    type: ActionTypes.REMOVE_NOTIFICATIONS,
  });
};

export const removeNotification = (messageId: number): void => {
  store.dispatch({
    type: ActionTypes.REMOVE_NOTIFICATION,
    payload: {
      id: messageId,
    },
  });
};

/**
 * Setzt die Daten Struktur der Message so das es ausgelesen wird in ein Modales Fenster
 * (mit header / body).
 *
 * @param translation die Translation
 * @param placeHolderValues die Platzhalter Werte
 */
const setModalData = (
  translation: Translation,
  placeHolderValues: []
): Message => {
  const message: Message = {
    id: 0,
    severity: ERROR,
  };
  if (translation) {
    message.message = '';
    if (translation.bezkurz && translation.bezkurz !== translation.bezlang) {
      message.header += translation.bezkurz;
    }
    if (translation.bezlang) {
      message.message += replacePlaceholderValues(
        translation.bezlang,
        1,
        placeHolderValues
      );
    }
  }

  return message;
};

/**
 * Setzt die Daten Struktur der Message so das es ausgelesen wird unter der Navbar
 * z.b. bei Auftrag Speichern.
 *
 * @param translation die Translation
 * @param placeHolderValues die Platzhalter Werte
 */
const setPanelData = (
  translation: Translation,
  placeHolderValues: []
): Message => {
  const message: Message = {
    id: 0,
    severity: INFO,
  };
  if (translation) {
    message.message = '';
    // TODO: translation.bezkurz !== translation.bezlang kann weg wenn die DB Tabelle
    // aufgeräumt wird. Bisher steht oft der Selbe Werte in der bezkurz / bezlang Spalten
    if (translation.bezkurz && translation.bezkurz !== translation.bezlang) {
      message.message += translation.bezkurz + ': ';
    }
    if (translation.bezlang) {
      message.message += replacePlaceholderValues(
        translation.bezlang,
        1,
        placeHolderValues
      );
    }
  }
  return message;
};

/**
 * Erzeugt eine Message mit der Überprüfung des TranslationKeys
 * @param key
 * @param severity
 * @param placeHolderValues
 * @param fieldName
 * @param id
 */
export const createMessage = (
  key: string,
  severity = INFO,
  placeHolderValues: [],
  fieldName?: string,
  id?: number
) => {
  const message: Message = { id: id, fieldname: fieldName, severity: severity };
  const translation = findTranslation(key);

  if (translation) {
    message.message = '';
    if (translation.bezkurz && translation.bezkurz !== translation.bezlang) {
      message.header += translation.bezkurz;
    }
    if (translation.bezlang) {
      message.message += replacePlaceholderValues(
        translation.bezlang,
        1,
        placeHolderValues
      );
    }
  } else {
    message.message = key;
  }

  return message;
};
